<template>
  <div id="hydwsh">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'hydwsh'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/member/approve/company/Hydwsh.vue